<script lang="ts">
export interface InfoDialogProps {
  title: string
}
</script>

<script setup lang="ts">
import { InformationCircleIcon } from '@heroicons/vue/24/outline'
import { useTemplateRef } from 'vue'
import { Button } from '#ui-kit/ui/button'
import { Dialog, DialogContent, DialogDescription, DialogTitle } from '#ui-kit/ui/dialog'

const props = defineProps<InfoDialogProps>()

const slots = defineSlots<{
  default?: () => unknown
}>()

const open = defineModel<boolean>('open', { default: false })

const footer = useTemplateRef<HTMLElement>('footer')

function focusAction(event: Event) {
  event.preventDefault()
  footer.value?.querySelector('button')?.focus()
}
</script>

<template>
  <Dialog v-model:open="open">
    <DialogContent role="alertdialog" @open-auto-focus="focusAction">
      <div class="flex flex-col gap-4 font-display">
        <div class="flex flex-col gap-2 [&>svg]:size-10">
          <InformationCircleIcon class="text-accent" aria-hidden="true" />
          <DialogTitle class="text-xl leading-normal tracking-normal wrap-anywhere text-primal">
            {{ props.title }}
          </DialogTitle>
          <DialogDescription v-if="slots.default" as="div" class="space-y-4 text-secondary">
            <slot />
          </DialogDescription>
        </div>
        <div ref="footer" class="flex">
          <Button block @click="open = false">Got It</Button>
        </div>
      </div>
    </DialogContent>
  </Dialog>
</template>
